import React from 'react';
import { IonContent } from '@ionic/react';
import { AppHeaderOverride } from './AppHeader';
import { NavigationMenu } from './navigation/NavigationMenu';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth } from './theme/utils';
import { IHeaderTabGroup } from './HeaderTabs';
import { SIDE_NAV_WIDTH } from './navigation/NavConstants';
import { IThemeColor } from './theme/IThemeColor';

const useStyles = createUseStyles({
    paddedContent: {
        '--padding-start': 'var(--ion-padding, 16px)', // from .ion-padding
        '--padding-end': 'var(--ion-padding, 16px)',
        '--padding-top': 'var(--ion-padding, 12px)',

        [mediaMinWidth.md]: {
            '--padding-start': '15%',
            '--padding-end': '15%',
            '--padding-top': '26px'
        },

        [mediaMinWidth.lg]: {
            '--padding-start': `calc(${SIDE_NAV_WIDTH}px + 20%)!important`,
            '--padding-end': '20%'
        }
    },

    content: {
        [mediaMinWidth.lg]: {
            '--padding-start': `${SIDE_NAV_WIDTH}px`
        }
    },

    skipContent: {
        width: '100%',
        height: '100%',
        [mediaMinWidth.lg]: {
            paddingLeft: `${SIDE_NAV_WIDTH}px`
        }
    }
});

interface IInnerhivePageProps {
    title?: string;
    children: React.ReactNode;
    hideAppHeader?: boolean;
    backgroundColor?: IThemeColor;
    skipAddingNavigation?: boolean;
    skipAddingIonContent?: boolean;
    tabs?: IHeaderTabGroup;
    'data-id'?: string;
    contentRef?: React.RefObject<HTMLIonContentElement>;
}

export const InnerhivePage: React.FC<IInnerhivePageProps> = ({
    title = '',
    children,
    backgroundColor,
    hideAppHeader = false,
    skipAddingNavigation,
    skipAddingIonContent,
    tabs,
    'data-id': dataId,
    contentRef
}) => {
    const classes = useStyles();

    return (
        <>
            {/* TODO: key is not ideal way to get AppHeaderOverride to detect changes */}
            <AppHeaderOverride key={title} title={title} hidden={hideAppHeader} tabs={tabs} />

            {!skipAddingIonContent && (
                <IonContent
                    id="page-content"
                    data-id={dataId}
                    ref={contentRef}
                    className={`${classes.content} ${!hideAppHeader ? classes.paddedContent : ''}`}
                    color={backgroundColor}
                >
                    {children}
                </IonContent>
            )}

            {skipAddingIonContent && (
                <div className={classes.skipContent}>
                    {children}
                </div>
            )}

            {!skipAddingNavigation && <NavigationMenu contentId="page-content" />}
        </>
    );
};
